import { headerConnect as connect } from 'components/Shared/connect';
import Icon from 'components/Shared/Icon';
import styles from './styles.scss';
import { toggleMainMenu } from 'components/MainMenu/actions';

interface MergedProps {
  toggleMainMenu: () => void;
}

export default connect<MergedProps>(undefined, dispatch => ({
  toggleMainMenu: () => dispatch(toggleMainMenu())
}))(({ toggleMainMenu }: MergedProps) => (
  <div className={styles.iconMenu} onClick={toggleMainMenu}>
    <Icon icon="icon-menu" className={styles.iconMenu} size="large" />
  </div>
));
